/**
 * Resolve a dot-notation key (e.g. "nav.dashboard") from a nested message tree.
 * Optional values: interpolate {key} in the message with values.key.
 */

import type { MessageTree } from "./types";

export function getMessage(
  messages: MessageTree | null | undefined,
  key: string,
  values?: Record<string, string | number>,
): string {
  if (!messages || !key) return key;
  const parts = key.split(".");
  let current: string | MessageTree | undefined = messages;
  for (const part of parts) {
    if (current == null || typeof current !== "object") return key;
    current = (current as Record<string, string | MessageTree>)[part];
  }
  let out = typeof current === "string" ? current : key;
  if (values && typeof out === "string") {
    for (const [k, v] of Object.entries(values)) {
      out = out.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
    }
  }
  return out;
}
